<h1 class="page-title" style="margin-bottom: 1rem">Probar asistente</h1>
<div class="grid">
  <div id="iframe-container">
    <div *ngIf="isLoading || (isIframeLoading && showiframe)" class="spinner">
      <div class="loading-dots">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
      </div>
    </div>
    <iframe
      id="iframe"
      title="Globot"
      [src]="widgetUrl | safe"
      *ngIf="showiframe"
      height="630"
      width="392"
      #iframe
    ></iframe>
  </div>
  <div class="panel">
    <div class="panel-toggle" (click)="configExpanded = !configExpanded">
      <div class="panel-toggle-summary">
        <span
          class="panel-toggle-color"
          [style.backgroundColor]="selectedColor"
          aria-hidden="true"
        ></span>
        <span class="panel-toggle-name">{{
          chatbotForm.get('name')?.value || 'Configuración'
        }}</span>
      </div>
      <span
        class="material-symbols-outlined panel-toggle-icon"
        [class.expanded]="configExpanded"
        aria-hidden="true"
        >expand_more</span
      >
    </div>
    <div class="inputs-form" [class.mobile-collapsed]="!configExpanded">
      <form [formGroup]="chatbotForm">
        <div class="panel-section">
          <div class="field">
            <label for="name">Nombre visible</label>
            <input
              pInputText
              id="name"
              formControlName="name"
              placeholder="Ejemplo: Sofía"
              [ngClass]="{
                'error-input':
                  chatbotForm.get('name')?.invalid &&
                  (chatbotForm.get('name')?.dirty || chatbotForm.get('name')?.touched)
              }"
            />
            <small
              class="error-message"
              *ngIf="
                chatbotForm.get('name')?.invalid &&
                (chatbotForm.get('name')?.dirty || chatbotForm.get('name')?.touched)
              "
            >
              <span *ngIf="chatbotForm.get('name')?.errors?.['required']"
                >El nombre es requerido</span
              >
              <span *ngIf="chatbotForm.get('name')?.errors?.['maxlength']"
                >El nombre tiene un límite de 20 caracteres</span
              >
            </small>
            <small
              class="field-hint"
              *ngIf="
                !(
                  chatbotForm.get('name')?.invalid &&
                  (chatbotForm.get('name')?.dirty || chatbotForm.get('name')?.touched)
                )
              "
              >Máximo 20 caracteres</small
            >
          </div>
          <div class="field">
            <label for="identifier">Nombre del operador</label>
            <input
              pInputText
              id="identifier"
              formControlName="identifier"
              placeholder="Ej: Asistente Ecoverde"
            />
            <small
              class="error-message"
              *ngIf="
                chatbotForm.get('identifier')?.invalid &&
                (chatbotForm.get('identifier')?.dirty || chatbotForm.get('identifier')?.touched)
              "
            >
              <span *ngIf="chatbotForm.get('identifier')?.errors?.['maxlength']"
                >El identificador tiene un límite de 20 caracteres</span
              >
            </small>
            <small
              class="field-hint"
              *ngIf="
                !(
                  chatbotForm.get('identifier')?.invalid &&
                  (chatbotForm.get('identifier')?.dirty || chatbotForm.get('identifier')?.touched)
                )
              "
              >Máximo 20 caracteres · se muestra en el widget</small
            >
          </div>
        </div>

        <div class="panel-section">
          <span class="section-label">Color principal</span>
          <div class="color-rows">
            <div class="color-row" *ngFor="let row of colorRows; trackBy: trackByColorRowIndex">
              <div
                class="color-card"
                *ngFor="let c of row; trackBy: trackByColorValue"
                [class.selected]="c.value === selectedColor"
                (click)="selectColor(c.value)"
              >
                <span class="color-dot" [style.backgroundColor]="c.value" aria-hidden="true"></span>
                <span class="color-name">{{ c.name }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="panel-section welcome-section">
          <label>Mensaje de bienvenida</label>
          <p-checkbox
            [ngModel]="welcomeEnabled"
            [ngModelOptions]="{ standalone: true }"
            [binary]="true"
            label="Activar mensaje de bienvenida"
            (onChange)="welcomeEnabled = $event.checked; onWelcomeToggle()"
          ></p-checkbox>
          <div class="field" *ngIf="welcomeEnabled">
            <input
              pInputText
              [value]="welcomeMessage"
              (input)="welcomeMessage = $any($event.target).value"
              placeholder="Ejemplo: ¡Hola! ¿En qué puedo ayudarte hoy?"
              [ngClass]="{ 'error-input': welcomeMessageError }"
            />
            <small class="error-message" *ngIf="welcomeMessageError"
              >El campo mensaje no puede estar vacío.</small
            >
            <ul class="welcome-hints">
              <li>Se muestra al inicio de cada conversación.</li>
              <li>
                Para ver el nuevo mensaje reinicia la conversación con el ícono
                <svg
                  class="hint-icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="11"
                  height="11"
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
                  <path
                    d="M3 12C3 9.61305 3.94821 7.32387 5.63604 5.63604C7.32387 3.94821 9.61305 3 12 3C14.516 3.00947 16.931 3.99122 18.74 5.74L21 8M21 8V3M21 8H16M21 12C21 14.3869 20.0518 16.6761 18.364 18.364C16.6761 20.0518 14.3869 21 12 21C9.48395 20.9905 7.06897 20.0088 5.26 18.26L3 16M3 16H8M3 16V21"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                del chat.
              </li>
            </ul>
          </div>
        </div>

        <div class="change-banner change-banner--warning" *ngIf="isDirty && !justSaved">
          <i class="pi pi-exclamation-circle" aria-hidden="true"></i>
          <span>Tienes cambios sin guardar</span>
        </div>
        <div class="change-banner change-banner--success" *ngIf="justSaved">
          <i class="pi pi-check-circle" aria-hidden="true"></i>
          <span>Todo guardado</span>
        </div>

        <button class="save" type="button" (click)="saveConfig()">
          <i class="pi pi-save" aria-hidden="true"></i>
          Guardar cambios
        </button>
      </form>
    </div>
  </div>
</div>
